// Strips fields that must never reach the analytics/BI pipeline from an
// Adyen stateData/extraData object before it's used in a GoogleAnalyticsHelper
// trackEvent(ANALYTICS_EVENTS.ADYEN_PAYMENT, ...) call: `paymentMethod`
// (cardholder name + client-side-encrypted card number/expiry/CVC) and the
// 3DS challenge/ACS token (~10KB base64, no analytics value — carried as
// `details` on stateData, but renamed to `threeDsDetails` when copied onto
// extraData in the isAdditionalDetails branch of authAdyen(), so both key
// names are stripped here) are dropped entirely, and `riskData.clientData`
// (a large base64 device-fingerprint SDK blob) is reduced to a boolean flag.
// Never use this on data that's actually sent to the real payment API
// (checkoutApi.processUrlPayment) — only on a copy destined for analytics.
// Found via a production Eventstream ingestion incident (2026-09-02): these
// fields were flowing into analytics-svc, BigQuery and Kusto unsanitized
// (`details`/`threeDsDetails` found in a second BigQuery pass after the
// initial fix — present even on payloads with no riskData/paymentMethod).
export const sanitizeAdyenAnalyticsData = data => {
  if (!data || typeof data !== 'object') return data;
  // eslint-disable-next-line no-unused-vars
  const {paymentMethod, details, threeDsDetails, ...rest} = data;
  if (rest.riskData && rest.riskData.clientData) {
    rest.riskData = {hasClientData: true};
  }
  return rest;
};
